<template>
  <v-layout column>
    <v-flex xs11 offset-xs0>
      <panel v-bind:title='title'>
        
        <UnitEdit v-if ='$store.state.isEditor' slot="action"/>
        <div slot="top">
          <H3>People attached to {{ title }} </H3>
          <PeopleSearchTable v-bind:forceUnitId="id" v-bind:showUnitCol='false'/>
        </div>         
      </panel>
            
    </v-flex>
  </v-layout>
</template>

<script>

import Panel from "@/components/Panel" ;
import PeopleSearchTable from "@/components/PeopleSearchTable" ;
import UnitService from "@/services/UnitService" ;
import UnitEdit from "./UnitEdit" ;

export default {
  components: {
    Panel, PeopleSearchTable, UnitEdit 
  },
  data () {
    return {
      id: parseInt(this.$route.params.id),
      unit: {},
      title: "Loading Unit " + this.$route.params.id
    }
  },
  async created () {
    await this.$getCodes() ;  // needed for everything - make sure we have them and they are up to date
  },  
  async mounted () {
    console.log("in unit mounted") ;

    await this.readData() ;
  },
  methods: {
    async readData () {

      const result = await UnitService.id(this.id) ;
      this.unit = result.data ;
      // console.log("Back from us, this.unit=" + JSON.stringify(result)) ;
      this.title = this.unit.v ;
    }
  }
};
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/components/Unit.vue